import { BlocksDealer } from '../logic/dealer/blocks-dealer';
import { RemoteRoundResultSubmitter } from '../../common/phaser/model/remote-round-result-submitter';
import { RemoteRoundParams, RoundParams } from '../../common/phaser/model/round-params';
import { RemoteDealer } from '../logic/dealer/remote-dealer';
import { BlocksListener } from '../game/blocks-listener';

export class BlocksRemoteRoundParams extends RemoteRoundParams {
  public readonly dealer: BlocksDealer;

  constructor(dealer: BlocksDealer, remoteRoundResultSubmitter: RemoteRoundResultSubmitter) {
    super(remoteRoundResultSubmitter);
    this.dealer = dealer;
  }

  public static create(gameListener: BlocksListener): BlocksRemoteRoundParams {
    const dealer = new RemoteDealer(gameListener);

    return new BlocksRemoteRoundParams(dealer, new RemoteRoundResultSubmitter(gameListener));
  }

  public static isRound(roundParams: RoundParams): roundParams is BlocksRemoteRoundParams {
    return roundParams instanceof BlocksRemoteRoundParams;
  }
}
